module.exports = __webpack_public_path__ + "img/ck_icon.327c3c85.png";